import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-solo-parent-id-template',
  templateUrl: './solo-parent-id-template.component.html',
  styleUrls: ['./solo-parent-id-template.component.scss']
})
export class SoloParentIdTemplateComponent implements OnInit {
  @Input() card: any;
  @Input() org: any;

  constructor() {}

  ngOnInit(): void {    
  }

  
  org_logo(): string {
    const logo = this.org?.contents?.find(orgCont => orgCont.type === 'header1');

    return (logo) ? logo?.valueURL : '';
  }

  userPhoto(): string {
    return this.card?.picture ?? '/assets/img/admin/broken-image.png';
  }
}
